import { useCallback, useEffect, useMemo, useState } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import {
  ZAI_NATIVE_SIDE_CHAT_OPEN_EVENT,
  ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT,
  ZAI_PAGES_EXCEPTION,
} from './zai-native-side-chat.consts'
import type { TZaiNativeSideChatModelReturn } from './zai-native-side-chat.types'

export const useZaiNativeSideChatModel = (): TZaiNativeSideChatModelReturn => {
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const shouldSideChatHidden = useMemo(() => ZAI_PAGES_EXCEPTION.some(page => matchPath(pathname, page)), [pathname])

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (shouldSideChatHidden && open) return
      setIsOpen(open)
    },
    [shouldSideChatHidden]
  )

  useEffect(() => {
    if (shouldSideChatHidden) setIsOpen(false)
  }, [shouldSideChatHidden])

  useEffect(() => {
    const handleOpenEvent = () => onOpenChange(true)
    const handleToggleEvent = () => setIsOpen(prev => (shouldSideChatHidden ? false : !prev))

    window.addEventListener(ZAI_NATIVE_SIDE_CHAT_OPEN_EVENT, handleOpenEvent)
    window.addEventListener(ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT, handleToggleEvent)

    return () => {
      window.removeEventListener(ZAI_NATIVE_SIDE_CHAT_OPEN_EVENT, handleOpenEvent)
      window.removeEventListener(ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT, handleToggleEvent)
    }
  }, [onOpenChange, shouldSideChatHidden])

  return { isOpen, onOpenChange }
}
